import React from "react";

function Checkbox3({checked, onChange}) {
  return (
    <label
      className="relative flex cursor-pointer items-center rounded-full series_tab_btn_checkbox"
      htmlFor="checkbox-2"
      data-ripple-dark="false"
    >
      <input
        type="checkbox"
        className={`before:content[''] peer relative h-5 w-5 mr-1 cursor-pointer appearance-none  border-2 bg-white border-black transition-all  checked:border-red-500 checked:bg-zinc-50 checked:before:bg-zinc-50 hover:before:opacity-10`}
       
        checked={checked}
        onChange={onChange}
      />
      <div className="pointer-events-none absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 text-red-600 opacity-0 transition-opacity peer-checked:opacity-100">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-2.5 w-2.5"
          viewBox="0 0 20 20"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"
        >
          <path
            fillRule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clipRule="evenodd"
          ></path>
        </svg>
      </div>
    </label>
  );
}

export default Checkbox3;
